import { render, staticRenderFns } from "./ArtistEdit.vue?vue&type=template&id=5649c907"
import script from "./ArtistEdit.vue?vue&type=script&lang=js"
export * from "./ArtistEdit.vue?vue&type=script&lang=js"
import style0 from "./ArtistEdit.vue?vue&type=style&index=0&id=5649c907&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports